import { render, staticRenderFns } from "./createSale.vue?vue&type=template&id=5bf77df5&"
import script from "./createSale.vue?vue&type=script&lang=js&"
export * from "./createSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports